import React from 'react';
import { FormattedMessage } from 'react-intl';
import BooleanAttribute from '../Fields/Boolean';
import
withDefinitionErrors,
{ WithDefinitionErrorsReturnProps }
    from '../../../../hoc/withDefinitionErrors/withDefinitionErrors';
import { InjectedIntlProps, injectIntl } from 'react-intl';

export interface AllowSlashProps extends WithDefinitionErrorsReturnProps, InjectedIntlProps {
    value?: boolean;
    onChange(required: boolean): any;
}

function AllowSlash(props: AllowSlashProps) {
    return (
        <BooleanAttribute
            hasErrors={props.hasErrors}
            errors={props.errors.map(e => props.intl.formatMessage(e))}
            attributeName={<FormattedMessage
                defaultMessage="Allow Slash"
                id="components.ContentDefinitionSchemaEditor.ContentDefinitionFieldEditing.Constraint.AllowSlash"
            />}
            titleTrue={<FormattedMessage id="AllowSlash.attributeTitle.value.true" defaultMessage="Yes" />}
            titleFalse={<FormattedMessage id="AllowSlash.attributeTitle.value.false" defaultMessage="No" />}
            helperTrue={<FormattedMessage
                id="AllowSlash.attributeHelper.value.true"
                defaultMessage="Allow forward slashes"
            />}
            helperFalse={<FormattedMessage
                id="AllowSlash.attributeHelper.value.false"
                defaultMessage="Do not allow forward slashes"
            />}
            onChange={value => props.onChange!(value)}
            value={props.value}
        />
    );
}

export default withDefinitionErrors(injectIntl(AllowSlash));
